export const STRAPI_SEO_INJECTION_KEY = 'STRAP_SEO_INJECTION_KEY'
